export class KalmanFilter {
  // Create a Kalman filter with the specified matrices.
  //   A - System dynamics matrix
  //   C - Output matrix
  //   Q - Process noise covariance
  //   R - Measurement noise covariance
  //   P - Estimate error covariance
  constructor({A, C, Q, R, P, dt}) {
    this.A = A;
    this.C = C;
    this.Q = Q;
    this.R = R;
    this.P0 = P;
    this.dt = dt;
    
    this.m = math.size(C).get([0]); // get rows
    this.n = math.size(A).get([0]); // get rows
    this.initialized = false;
  
    this.I = math.identity(this.n);
    
    this.x_hat = null;
    this.x_hat_new = null;
  }
  
  init({t0=0, x0=null}) {
    this.x_hat = x0 || math.zeros(this.n);
    this.t0 = t0;
    
    this.P = this.P0;
    this.t = t0;
    
    this.initialized = true;
  }

  update(y) {
    if(!this.initialized) {
      throw new Error("KalmanFilter not initialized");
    }
    
    this.x_hat_new = math.multiply(this.A, this.x_hat)
    this.P = math.add(math.multiply(math.multiply(this.A, this.P), math.transpose(this.A)), this.Q);
    
    let k0 = math.multiply(this.P, math.transpose(this.C));
    let k1 = math.add(math.multiply(math.multiply(this.C, this.P), math.transpose(this.C)), this.R);
    this.K = math.multiply(k0, math.inv(k1));
    
    let x0 = math.subtract(y, math.multiply(this.C, this.x_hat_new));
    this.x_hat_new = math.add(this.x_hat_new, math.multiply(this.K, x0));
    
    this.P = math.multiply(math.subtract(this.I, math.multiply(this.K, this.C)), this.P);
    
    this.x_hat = this.x_hat_new;
    
    this.t += this.dt;
  }
  
  state() {
    return this.x_hat;
  }
  time() {
    return this.t;
  }
}